<template>
  <div @touchmove.stop="">
    <div class="mall-popup-mask" @click="handleHide(2)" v-show="value" @touchmove.prevent></div>
    <transition :name="popupTransition">
      <div class="mall-popup-cont" v-if="value" :style="{maxHeight}">
        <slot name="top">
          <div :class="onePurache ? 'mall-popup-title__two' : 'mall-popup-title'" v-if="title">{{title}}</div>
        </slot>
        <div class="mall-popup-scroll">
          <slot></slot>
        </div>
        <slot name="bottom"></slot>

        <div class="mall-popup-close" v-if="showCloseBtn" @click="handleHide"></div>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: 'MallPopup',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    maxHeight: {
      type: String,
      default: '80%'
    },
    popupTransition: {
      type: String,
      default: 'slide-fade'
    },
    closeOnClickModal: {
      default: function() {
        return true;
      }
    },
    showCloseBtn: {
      type: Boolean,
      default: true
    },
    onePurache: {
      type: Boolean,
      default: false
    },
    bodyClassName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShow: false, // 记录状态，避免重复调用onOpen、onClose
    };
  },
  computed: {
    bodyClass() {
      return this.bodyClassName ? ['layout-scroll--no', this.bodyClassName] : ['layout-scroll--no'];
    }
  },
  watch: {
    value(val) {
      // document.body.style.overflow = val ? 'hidden' : 'visible';
      if (val) {
        document.body.classList.add(...this.bodyClass);
      } else {
        document.body.classList.remove(...this.bodyClass);
      }

      if (this.isShow === val) {
        return;
      }
      this.isShow = val ? true : false;
      this.$emit(val ? 'onOpen' : 'onClose');
    },
  },
  beforeDestroy() {
    this.handleHide();
    // document.body.style.overflow = 'visible';
    document.body.classList.remove('layout-scroll--no', 'layout-position--fixed');
  },
  methods: {
    handleHide(val) {
      // val: 2-点击遮罩层
      if (val === 2 && !this.closeOnClickModal) {
        return;
      }
      this.isShow = false;
      this.$emit('input', false);
      this.$emit('onClose');
    }
  }
};
</script>
<style lang="stylus" scoped>
.mall-popup-mask {
  position: fixed;
  z-index: 50;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
}
.mall-popup-cont {
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0px;
  left: 0px;
  max-width: 100%;
  max-height: 80%;
  min-width: 100%;
  min-height: 50px;
  padding-bottom: 20px;

  background: #fff;
  z-index: 51;
  transform: translateY(0%);
  box-sizing: border-box;
  border-radius: 20px 20px 0px 0px;

  .mall-popup-title {
    position: relative;
    display: flex;
    align-items: center;
    margin: 0.18rem 0.2rem;
    line-height: .25rem;
    font-size: .18rem;
    font-weight: 700;
    background: #fff;
    color: #41414d;
    border-radius: 20px 20px 0px 0px;
    &:before {
      content: ' ';
      display: block;
      width: 4px;
      height: 18px;
      margin-right: 4px;
      background: #FF5F2E;
      border-radius: 2px;
    }
  }

  .mall-popup-title__two {
    width 85%
    position: relative;
    display: flex;
    align-items: center;
    margin: 0.18rem 0.2rem;
    line-height: .25rem;
    font-size: .18rem;
    font-weight: 700;
    background: #fff;
    color: #41414d;
    border-radius: 20px 20px 0px 0px;
  }
  .mall-popup-scroll {
    flex: 1;
    padding: 0 0.2rem;
    overflow: auto;
    -webkit-overflow-scrolling:touch;
  }

  .mall-popup-close {
    position: absolute;
    width: 24px;
    height: 24px;
    top: 20px;
    right: 15px;
    background: url('../images/icon-close.png') no-repeat center center;
    background-size: contain;
  }
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s linear;
}
.slide-fade-enter,
.slide-fade-leave-active {
  transform: translateY(100%);
  opacity: 0;
}
</style>